import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Rx';
import { CommonService } from '../common.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TranactionService {

    constructor(private router: Router, private _commonservice: CommonService) { }
_getonlinetrans(mobileno)
{
    const params = new HttpParams().set('mobileno',mobileno);
    return this._commonservice.getAPI('/getonlinetransactions', params, 'YES')
}

_savetransdetails(data): Observable<any>
{
    try {
          return this._commonservice.postAPI('/Savetransdetails',data);
      }
      catch (e) {
        this._commonservice.showErrorMessage(e);
      }
}
_gettranstokentransdetails(data): Observable<any>
{
    try {
          return this._commonservice.postAPI('/getchecksum',data);
          debugger;
      }
      catch (e) {
        this._commonservice.showErrorMessage(e);
      }
}

_gettransdetails(key,orderid)
{
    const params = new HttpParams().set('mid',key).set('orderid',orderid);
    return this._commonservice.getAPI('/gettransstatus', params, 'YES')
}

_getorderdetails(orderid)
{
    const params = new HttpParams().set('orderid',orderid);
    return this._commonservice.getAPI('/orderdetails', params, 'YES')
}
_updatetransdetails(data): Observable<any>
{
    try {
          let updatedata = JSON.stringify(data)
          return this._commonservice.postAPI('/Updatetransdetails', updatedata);  
      }
      catch (e) {
        this._commonservice.showErrorMessage(e);
      }
}
GetSubscriberChitDetails(usermobileNo)
{
    const params = new HttpParams().set('Mobileno',usermobileNo);
    return this._commonservice.getAPI('/GetSubscriberChitDetails', params, 'YES')
}

GetSubscriberChitDetailsbasedongroupcode(groupcodetickectno)
{
    const params = new HttpParams().set('groupcodetickectno',groupcodetickectno);
    return this._commonservice.getAPI('/GetSubscriberChitDetailsbasedongroupcode', params, 'YES')
}

GetSubscriberauctionDetails(usermobileNo)
{
    const params = new HttpParams().set('Mobileno',usermobileNo);
    return this._commonservice.getAPI('/GetSubscriberauctionDetails', params, 'YES')
}

Savebidoffer(data): Observable<any>
{
    try {
          return this._commonservice.postAPI('/Savebidoffer',data);
      }
      catch (e) {
        this._commonservice.showErrorMessage(e);
      }
}

getmaxbidoffer(vchgrpcode,auctmonth,vchbranchname)
{
    const params = new HttpParams().set('GroupCode',vchgrpcode).set('Branchname',vchbranchname).set('auctionmonth',auctmonth);
    return this._commonservice.getAPI('/getmaxbidoffer', params, 'YES')
}
}